import React, {useState, useEffect} from 'react';
import { FaDatabase } from "react-icons/fa";
import Accordion from "../../../../components/Accordion";
import { ExtensionContent } from '../../../../utils/content';
import DialogModal from '../../../../components/Modal/DialogModal';


export default function EventsLists({userInfo, eventList, setEnableSaveBtn, titleLists, setFieldData, enableExtensionModal}) {
    const handleTitleAndMultiselectValue = (updateId, key, value) =>{
        setFieldData((prev)=>{
          const filterPrev = prev.map((item) => {
            if (item.id === updateId) {
              return { ...item, [key]: value }; 
            }else{
              return item;
            }
          })
          if (!filterPrev.some(item => item.id === updateId)) {
            prev.push({ id: updateId, [key]: value });
            return prev
          }else{
            return filterPrev;
          }
        })
      }
      const handleMultiSelect = (e, index) => {
          eventList[index]["multiSelect"] = e;
          handleTitleAndMultiselectValue(eventList[index]._id, 'multiSelect', e);
        setEnableSaveBtn(true);
        return;
      };
    
      const handleTitle = (event, index) => {
        const { name, value } = event.target;
        eventList[index]["title"] = value;
          handleTitleAndMultiselectValue(eventList[index]._id, 'title', value)  
          setEnableSaveBtn(true);
          return;
      };
    
    //   useEffect(() => {
    //     (async()=>{
    //       setTimeout(async() => {
    //         console.log("you find me ", userInfo);
    //         if (userInfo) {
    //           const pageRes = await pageInfo();
    //           setEnableExtensionModal(pageRes);
    //           console.log("checking pageRes :", pageRes);
    //         }
    //       }, 2500);
    //     })()
    // }, []);
  return (
    <>
     {eventList.length !== 0 && userInfo && eventList.map((prop, index) => {
          titleLists.push({
            id: prop._id.toString(),
            value: prop?.title,
            label: prop?.title,
          });
          return (
            <Accordion
              key={index}
              index={index}
              icon={<FaDatabase />}
              url={prop.pathname}
              multiSelect={prop?.multiSelect}
              pageInfo={prop.updatedEvents?.allEvents || prop.allEvents} 
              handleChange={handleTitle}
              handleMultiSelect={handleMultiSelect}
              titleLists={titleLists}
              pageTitle={prop?.title}
              {...prop}
            />
          );
        })}
        {!enableExtensionModal && eventList.length == 0 &&  <><DialogModal content={ExtensionContent.extensionInstalltionContent}/></>}
      
    </>
  )
}
